module.exports = __webpack_public_path__ + "img/3730111_s.692cfbc0.jpg";